import { IonButton } from "@ionic/react";
import { useHistory } from "react-router-dom";
import { useRecoilState } from "recoil";
import { currentAssessmentState, defaultAssessment } from "../../data/atoms";

interface Props {
  setIncompleteTest: Function;
  onChildClick: Function;
}
const IncompleteTestModal: React.FC<Props> = ({
  setIncompleteTest,
  onChildClick,
}) => {
  let history = useHistory();
  //   const [currentAssessment, setcurrentAssessmentState] = useRecoilState(
  //     currentAssessmentState
  //   );

  //   const ReDoTest = () => {
  //     setIncompleteTest(false);
  //     onChildClick("Redo");
  //   };

  const ExitnDiscard = () => {
    setIncompleteTest(false);
    // history.replace("/phone-height-requirement");
    history.push("/patient-page");
  };

  const ExitnSave = () => {
    setIncompleteTest(false);
  };

  return (
    <>
      <div className="incomplete-test-modal">
        {/* <div className="d-flex justify-content-end">
          <svg
            onClick={() => {
              setIncompleteTest(false);
            }}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M20.9999 20.909L2.90845 2.90918M21 2.90918L2.90845 20.9091"
              stroke="#D1D1D1"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div> */}
        <div className="text-center flex-column">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="130"
            height="131"
            viewBox="0 0 130 131"
            fill="none"
          >
            <path
              d="M32.4261 121.749C42.3246 127.481 53.5606 130.5 64.9991 130.5C69.8315 130.5 73.749 126.582 73.749 121.75C73.749 116.918 69.8315 113 64.9991 113L64.9991 112.95C56.649 112.95 48.4467 110.746 41.2208 106.562C33.9948 102.377 28.0011 96.36 23.845 89.1175C19.6888 81.8751 17.5175 73.6642 17.5502 65.314C17.5829 56.9638 19.8186 48.7702 24.0314 41.5606C28.2442 34.351 34.2849 28.3808 41.5434 24.253C48.8019 20.1252 57.0212 17.986 65.371 18.0515C73.7209 18.1169 81.9056 20.3847 89.0985 24.6258C95.759 28.5529 101.351 34.0431 105.397 40.6103C106.507 44.1678 109.827 46.7499 113.75 46.7499C118.583 46.7499 122.5 42.8324 122.5 37.9999C122.5 36.4474 122.096 34.9893 121.387 33.7252L121.626 33.5901C116.011 23.6247 107.865 15.3176 98.012 9.50794C88.1587 3.69823 76.9468 0.591664 65.5086 0.502005C54.0705 0.41233 42.8112 3.34274 32.868 8.99724C22.9248 14.6517 14.6499 22.8301 8.87891 32.7063C3.10797 42.5824 0.045434 53.8066 0.000604647 65.2452C-0.0442399 76.6838 2.93023 87.9317 8.62358 97.8528C14.3169 107.774 22.5275 116.017 32.4261 121.749Z"
              fill="#802392"
            />
            <path
              d="M87.7565 113.314C84.2489 115.213 82.9447 119.596 84.8437 123.104C86.7427 126.611 91.1257 127.915 94.6333 126.016C97.2136 124.62 99.6907 123.048 102.051 121.317C105.268 118.958 105.963 114.438 103.604 111.222C101.245 108.005 96.7257 107.31 93.5091 109.668C91.672 111.016 89.7506 112.234 87.7565 113.314Z"
              fill="#802392"
            />
            <path
              d="M107.323 94.568C105.242 97.9709 106.313 102.417 109.716 104.498C113.119 106.579 117.564 105.507 119.645 102.104C121.151 99.6427 122.51 97.0742 123.711 94.4121C125.352 90.7764 123.735 86.499 120.099 84.8583C116.463 83.2176 112.186 84.8349 110.545 88.4706C109.592 90.5841 108.514 92.6201 107.323 94.568Z"
              fill="#802392"
            />
            <path
              d="M115.453 68.4087C115.218 72.3906 118.256 75.809 122.237 76.0441C126.219 76.2792 129.638 73.2418 129.873 69.2599C129.957 67.8281 130 66.3851 130 64.9324C130 63.4797 129.957 62.0367 129.873 60.6048C129.638 56.623 126.219 53.5856 122.237 53.8207C118.256 54.0557 115.218 57.4742 115.453 61.4561C115.521 62.6047 115.556 63.7638 115.556 64.9324C115.556 66.101 115.521 67.2601 115.453 68.4087Z"
              fill="#802392"
            />
          </svg>
          <h1 className="assesment-modal-label mb-0">Incomplete Test</h1>
          <p className="assesment-modal-desc">This test is incomplete.</p>
          <p className="assesment-modal-desc mt-0">
            {" "}
            Please exit and discard to try again.
          </p>
        </div>
        <IonButton
          placeholder={undefined}
          className="blue-btn"
          onClick={() => {
            ExitnDiscard();
          }}
        >
          Exit & Restart
        </IonButton>
        {/* <div className="two-col-btn">
          <IonButton
            placeholder={undefined}
            onClick={() => {
              ExitnDiscard();
            }}
            className="blue-outline-btn"
          >
            Exit & Discard
          </IonButton>
          <IonButton
            placeholder={undefined}
            onClick={() => {
              ExitnSave();
            }}
            className="blue-btn"
          >
            Exit & Save
          </IonButton>
        </div> */}
      </div>
    </>
  );
};
export default IncompleteTestModal;
